export const EMAIL = "andreas@falkenbergtech.com";

export const MARQUEE_ITEMS = [
  "LLVM",
  "MLIR",
  "PYTORCH",
  "ONNX",
  "CUSTOM BACKENDS",
  "GRAPH PARTITIONING",
  "QUANTIZATION",
  "SYSTEMC",
  "FPGA / HLS",
  "KERNEL CODEGEN",
  "HW-SW CO-DESIGN",
];

export const OFFERINGS = [
  {
    n: "01",
    icon: "Network",
    title: "LLVM / MLIR Compiler Architecture",
    desc: "End-to-end compiler stacks for custom silicon: dialect design, pass pipelines, scheduling and codegen shaped around your hardware.",
    tags: ["DIALECTS", "PASS PIPELINES", "CODEGEN", "COST MODELS"],
  },
  {
    n: "02",
    icon: "Workflow",
    title: "PyTorch / ONNX Lowering & Custom Backends",
    desc: "Bridging model graphs to your target: torch-mlir / ONNX lowering paths, custom backend integration, operator coverage and numerics that hold.",
    tags: ["TORCH-MLIR", "ONNX", "BACKEND HOOKS", "NUMERICS"],
  },
  {
    n: "03",
    icon: "Split",
    title: "Hardware-Aware Partitioning & Quantization",
    desc: "Making models fit the machine: partitioning across compute tiles, quantization and QAT strategy, memory-aware scheduling and tiling.",
    tags: ["PARTITIONING", "QUANT / QAT", "TILING", "MEMORY PLANNING"],
  },
  {
    n: "04",
    icon: "Cpu",
    title: "ASIC / SoC & FPGA, SystemC Co-Design",
    desc: "Working the hardware-software boundary: ISA and intrinsic feedback, SystemC performance models, FPGA bring-up and early compiler validation for SoC teams.",
    tags: ["SYSTEMC", "FPGA BRING-UP", "ISA FEEDBACK", "PERF MODELING"],
  },
];

export const EXPERIENCE = [
  {
    company: "AMD / Xilinx",
    role: "Ryzen AI",
    impact: [{ t: "Upstream torch-mlir contributions and custom-backend work lowering ONNX/PyTorch models onto Ryzen AI NPUs — including NPU kernel integration and compiler validation." }],
  },
  {
    company: "BrainChip",
    role: "Sole Compiler Engineer",
    impact: [
      {
        t: "Built the complete MLIR-based compiler stack for BrainChip's next-generation neuromorphic processor — from ONNX, PyTorch, and TensorFlow graph ingestion through custom dialect design, middle-end optimization passes (fusion, tiling, quantization, layout), custom ISA backend codegen, and runtime integration. Defined the correctness validation strategy and led a researcher to scale it to 800+ test cases.",
      },
    ],
  },
  {
    company: "d-Matrix",
    role: "Inference silicon",
    impact: [{ t: "Graph-to-hardware mapping for transformer inference on in-memory compute." }],
  },
  {
    company: "Metawave",
    role: "Radar perception",
    impact: [
      { t: "Radar accuracy " },
      { t: "69% → 95%", stat: true },
      { t: " — signal-chain ML taken from lab to field." },
    ],
  },
  {
    company: "Ostendo",
    role: "Photonic display",
    impact: [{ t: "Designed the backend ASIC for a photonic embedded display from first principles through physical tapeout — architecture, RTL, and validation." }],
  },
];

export const LINKS = {
  scholar: "https://scholar.google.com/citations?user=LbZS3pAAAAAJ&hl=en",
  linkedin: "https://www.linkedin.com/in/andreas-falkenberg-91b8571/",
  github: "https://github.com/afalkenberg1",
};
